import { IApiRiskTreatmentAction } from '@mitie/risk-register-api-types';

import * as Api from './api';

export function getRiskTreatmentActionsForRisk(registerId: number, riskId: number) {
	return Api.get<IApiRiskTreatmentAction[]>(`risk-registers/${registerId}/risks/${riskId}/treatment-actions`);
}
